import { OwnedObjectType } from '../Inventory/OwnedObjects';
import { DisplayObject } from '../DisplayObject';
import { Button } from '../Base/Button';
import { KioskFnType } from '../../../hooks/kiosk';

export type KioskItemProps = {
  kioskId: string;
  hasKiosk: boolean;
  item: OwnedObjectType;
  showFn: KioskFnType;
};

export function KioskItem({ item, showFn }: KioskItemProps) {
  return (
    <DisplayObject item={item}>
      <>
        {
          <Button
            loading={false}
            className="app-tab-button app-loader-button bg-primary md:col-span-2"
            onClick={() => showFn(item)}
          >
            Show Details
          </Button>
        }
      </>
    </DisplayObject>
  );
}
